// İSG uzmanı portalı — Belge Şeması Yönetimi (Document Schemas) erişim sondası (route guard
// UX). `useContractorsAccess`i BİREBİR izler (api-contract §27 modül notu): asıl yetki
// backend'dedir (`[ModuleAction("document-schemas", …)]`); bu sonda yalnız UX görünürlüğüdür —
// hafif bir liste probu (`GET /document-schemas/types?page=1&pageSize=1`) çeker:
//   - 2xx  → erişim var (granted) → Belge Şemaları kabuğu + menü görünür
//   - 403  → yetki yok (forbidden) → gizli menü + 403 sayfası
//   - diğer (404/503/ağ) → servis/veri kullanılamıyor (unavailable) → yeniden dene

import { ApiError, documentSchemasApi } from '@isgportal/shared';
import { useQuery } from '@tanstack/react-query';
import { schemasKeys } from './schemasKeys';

export type DocumentSchemasAccessStatus = 'loading' | 'granted' | 'forbidden' | 'unavailable';

export interface DocumentSchemasAccess {
  status: DocumentSchemasAccessStatus;
  refetch: () => void;
}

export function useDocumentSchemasAccess(): DocumentSchemasAccess {
  const query = useQuery({
    queryKey: schemasKeys.access(),
    queryFn: () => documentSchemasApi.listDocumentTypes({ page: 1, pageSize: 1 }),
    retry: false,
    staleTime: 5 * 60_000,
  });

  let status: DocumentSchemasAccessStatus;
  if (query.isPending) {
    status = 'loading';
  } else if (query.isSuccess) {
    status = 'granted';
  } else if (query.error instanceof ApiError && query.error.statusCode === 403) {
    status = 'forbidden';
  } else {
    status = 'unavailable';
  }

  return { status, refetch: () => void query.refetch() };
}
